// extracted by mini-css-extract-plugin
export var infoItem = "_rr-2";
export var title = "_rr-0";
export var value = "_rr-1";